export function isTerritoryLayer(layer) {
  const normalize = (value) => String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const id = normalize(layer.layerId);
  const type = normalize(layer.layerType);
  const name = normalize(layer.displayName);
  return ['territory', 'traditional lands', 'traditional land', 'traditional territory'].includes(id)
    || ['territory', 'traditional land', 'traditional lands', 'traditional territory'].includes(type)
    || (/\brsmin\b/.test(`${id} ${name}`) && /\b(territory|territories|traditional lands)\b/.test(`${id} ${name}`));
}
